module.exports = __webpack_public_path__ + "img/COPY.468ba268.svg";